// Libraries
import React, { useState, useEffect } from "react"
import { connect } from "react-redux"
import StyledDialog from "../../../../../../../components/StyledDialog/StyledDialog"
import {Container, Label} from "../../../../../../../structureComponents"
import StyledButton from "../../../../../../../components/StyledButton/StyledButton"
import StyledInput from "../../../../../../../components/StyledInput/StyledInput"
import ImageGroup from "../../../../../../../store/modules/imageGroups/model"
import {updateImageGroup} from "../../../../../../../store/modules/imageGroups/actions"
import {setSnackbarState} from "../../../../../../../store/modules/global/actions";


function UpdateImageGroupDialog({
    active = false,
    onClose = () => ({}),
    currentVenture,
    imageGroup,
    dispatchUpdateImageGroup = () => ({}),
    dispatchSnackbar
}) {
    // States
    const [userHasChanges, setUserHasChanges] = useState(false)
    const [loading, setLoading] = useState(false)
    const [internalImageGroup, setInternalImageGroup] = useState(new ImageGroup({}))

    // Mounted
    useEffect(() => {
        setInternalImageGroup(imageGroup)
    }, [])

    // Watchers
    useEffect(() => {
        if (active) {
            setInternalImageGroup(imageGroup)
        }
    }, [active])

    // Methods
    const handleClose = () => {
        onClose()
        resetLocalState()
    }

    const handleCreateImageGroup = async (e) => {
        try {
            e.preventDefault()
            setLoading(true)

            await dispatchUpdateImageGroup({
                corporationId: currentVenture.corporationId,
                ventureId: currentVenture.id,
                imageGroupId: imageGroup.id
            }, {
                name: internalImageGroup.name
            })

            setLoading(true)
            dispatchSnackbar({
                type: "success",
                active: true,
                message: "Grupo de imagem atualizado com sucesso"
            })
            handleClose()
        } catch (error) {
            dispatchSnackbar({
                type: "error",
                active: true,
                message: "Infelizmente ocorreu um erro"
            })
        } finally {
            setLoading(false)
        }
    }

    const handleImageGroupNameOnChange = (e) => {
        const imageGroupName = e.target.value
        setInternalImageGroup({ ...imageGroup, name: imageGroupName })
        setUserHasChanges(true)
    }

    const resetLocalState = () => {
        setTimeout(() => {
            setUserHasChanges(false)
            setInternalImageGroup(new ImageGroup({}))
        }, 1000)
    }


    return (
        <StyledDialog
            title="Criar grupo de imagem"
            active={active}
            onClose={handleClose} maxWidth="sm">
            <form onSubmit={handleCreateImageGroup}>
                <Container>
                    <Label bold>Nome</Label>
                    <Container mt="10px">
                        <StyledInput
                            placeholder="Nome do grupo de imagem"
                            value={internalImageGroup.name}
                            onChange={handleImageGroupNameOnChange} />
                    </Container>
                </Container>
                <Container flex alignCenter justifyEnd mt="40px">
                    <Container>
                        <StyledButton
                            kind="primary-outlined"
                            onClick={handleClose}>
                            Cancelar
                        </StyledButton>
                    </Container>
                    <Container disabled={!userHasChanges} ml="10px">
                        <StyledButton
                            disabled={!userHasChanges}
                            kind="primary" type="submit"
                            loading={loading}>
                            Atualizar
                        </StyledButton>
                    </Container>
                </Container>
            </form>
        </StyledDialog>
    )
}

const mapStateToProps = (state) => ({
    currentVenture: state.ventures.currentVenture,
})

const mapDispatchToProps = (dispatch) => ({
    async dispatchUpdateImageGroup({ corporationId, ventureId, imageGroupId }, { name }) {
        await dispatch(updateImageGroup({ corporationId, ventureId, imageGroupId }, { name }))
    },

    dispatchSnackbar({ message, type, active }) {
        dispatch(setSnackbarState({ message, type, active }))
    }
})


export default connect(mapStateToProps, mapDispatchToProps)(UpdateImageGroupDialog)
